import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegisterGuard } from '../../../common/guards/register.guard';
import { AuthDesktopComponent } from './auth-desktop.component';
import { LoginRegisterDesktopPageComponent } from './pages/login-register-desktop-page/login-register-desktop-page.component';
import { VerificationDesktopPageComponent } from './pages/verification-desktop-page/verification-desktop-page.component';
import { PickNameDesktopPageComponent } from './pages/pick-name-desktop-page/pick-name-desktop-page.component';

const routes: Routes = [
  {
    path: '',
    component: AuthDesktopComponent,
    children: [
      {
        path: 'register',
        component: LoginRegisterDesktopPageComponent,
      },
      {
        path: 'verification/:phoneNumber',
        component: VerificationDesktopPageComponent,
        canActivate: [RegisterGuard],
      },
      {
        path: 'name',
        component: PickNameDesktopPageComponent,
        canActivate: [RegisterGuard],
      },
      {
        path: '',
        redirectTo: 'register',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthDesktopRoutingModule {}
